import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol As Your Flutter App Development Company in
              Dubai
            </h2>
            <p>
              You can easily rely on TekRevol as your Flutter app development
              company in Dubai based on their expertise in this technology. We
              prioritize your business goals and user satisfaction above all
              else to give you a competitive edge in the market. Our experienced
              team of developers, designers, and consultants collaborate closely
              with you to bring your app to life. That’s how we ensure a smooth
              and efficient development process. From strategic planning to
              post-launch support, we are committed to meeting your expectations
              and enhancing your overall business presence.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let’s Connect
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <StaticImage
              src="../../images/location_new/fold7/flutter_dubai_choose.webp"
              alt="Flutter development in Dubai illustration"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={525}
              height={804}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
